export const FILTER_NAME = 'Ещё фильтры';
export const FILTER_NAME_REDESIGN = 'Фильтры';
